import { Controller } from "stimulus"
import Rails from "@rails/ujs";

export default class extends Controller {
  static targets = [
    'form', 'flash', 'flashContent', 'submitButton', 'nextButton', 'nextUrl', 'modelAnswer', 'reloadableContent',
    'lastQuestion', 'userAnswerArea'
  ]

  connect(){
    const self = this;
    // this.element.addEventListener("question-controller::validated", function(event) {
    //   console.log("triggering a submit function in survey response controller.....")
    //   self.submit(event)
    // })

    window.addEventListener("uploader::uploadRemoved", function() {
      self.submitButtonTarget.classList.remove("state--disabled")
    })

    window.addEventListener("uploader::uploadCanceled", function() {
      self.submitButtonTarget.classList.remove("state--disabled")
    })

    window.addEventListener("audioRecorder::audioRemoved", function() {
      self.submitButtonTarget.classList.remove("state--disabled")
    })
  }

  displayFlash(state, message){
    this.toggleFlash(true)
    this.flashContentTarget.classList.add("state--" + state)
    this.flashContentTarget.innerHTML = message
  }

  toggleFlash(show = false){
    show ? this.flashTarget.classList.remove("hidden") : this.flashTarget.classList.add("hidden")
  }

  submissionSuccessful(response, status){
    // Show user answer with model answer
    this.dispatchRefreshContentEvent()
  }

  submissionFailed(response, status){
    this.displayErrorMessage(response["errors"]["answers.asset.attachment"])
    this.nextUrlTarget.innerHTML = `${response["refresh_url"]}.json`
    self = this

    setTimeout(function() {
      self.dispatchRefreshContentEvent()
    }, 5000);

  }

  dispatchRefreshContentEvent(){
    // const detail = this.hasSubmitButtonTarget ? {"scrollableTarget": this.submitButtonTarget} : {"scrollableTarget": this.nextButtonTarget}
    this.reloadableContentTarget.dispatchEvent(new Event("refresh-content"))
  }

  displayErrorMessage(attachmentErrors) {
    if(attachmentErrors == undefined) {
      this.displayFlash("danger", "Sorry something went wrong - hold on, we'll get you back to where you should be. If things still don't work, you can get in touch at help@GTPCG.com")
    } else {
      this.displayAttachmentErrorMessage(attachmentErrors)
    }
  }

  displayAttachmentErrorMessage(attachmentErrors) {
    if(attachmentErrors.filter(error => error.startsWith("type must be one of")).length > 0) {
      this.displayFlash("danger", "Your file is in an unknown format. Please try to upload another file and email help@GTPCG.com if it happens again.")
    } else{
      this.displayFlash("danger", "Something went wrong when uploading your file. Please try again and email help@GTPCG.com if it happens another time.")
    }

  }
  reloadForm(event) {
    event.preventDefault()
    event.stopPropagation()

    this.nextButtonTarget.classList.add("processing")
    this.nextButtonTarget.classList.add('state--disabled')
    this.nextButtonTarget.disabled = true

    if (this.lastQuestionTarget.innerText == "false") {
      this.dispatchRefreshContentEvent()
      // setTimeout(() => { window.scrollTo({top: 0}) }, 100);
    } else {
      location.href = this.nextButtonTarget.href
    }
  }

  submit(event){
    event.preventDefault()

    const url = this.formTarget.getAttribute("action") + ".json"
    const self = this;

    this.submitButtonTarget.classList.add("processing")
    this.submitButtonTarget.classList.add('state--disabled')
    this.submitButtonTarget.disabled = true

    Rails.ajax({
      type: "post",
      url: url,
      data: new FormData(this.formTarget),
      success: function(response, status) {self.submissionSuccessful(response, status)},
      error: function(response, status) {self.submissionFailed(response, status)}
    })
  }

}
